<template>
	<v-app-bar color="white" fixed :height="nowWidth > 784 ? 90 : 80" class="app-header-layout" flat>
		<v-layout wrap align-center v-if="nowWidth > 784">
			<div class="header-bar"></div>
			<div class="logo_1 cursor" @click="$router.push('/')"></div>
			<v-spacer></v-spacer>
			<v-layout justify-end style="margin-right:10%; margin-top: 8px;">
				<div v-for="(tab, i) in $store.state.tabList" :key="i" class="tab-css-1">
					<div class="number cursor">0{{ i + 1 }}</div>
					<div class="Title cursor" :style="i < 4 ? 'padding-right: 40px;' : 'padding-right: 0px;'" @click="titleGoto(tab.link)">
						{{ tab.title }}
					</div>
				</div>
			</v-layout>
		</v-layout>
		<v-layout v-else justify-center align-center wrap>
			<div class="header-bar"></div>
			<div class="logo_1 cursor" @click="$router.push('/')" style="width:85px; height:53px; margin: 0; margin-top:11px;"></div>
			<div class="m-header-icon" @click="showMenus = !showMenus">
				<v-img width="30" height="30" src="/image/m_menu_icon.png"></v-img>
			</div>
			<v-layout wrap :style="`background-color:white;`" v-if="showMenus">
				<v-flex xs12 v-for="(list, listIndex) in $store.state.tabList" :key="listIndex">
					<v-divider></v-divider>
					<v-btn text color="#2767A5" @click="titleGoto(list.link)" block>
						{{ list.title }}
					</v-btn>
					<v-divider v-show="listIndex === $store.state.tabList.length - 1"></v-divider>
				</v-flex>
			</v-layout>
		</v-layout>
	</v-app-bar>
</template>
<script>
export default {
	data() {
		return {
			showMenus: false,
			screenWidth: window.innerWidth,
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		titleGoto(link) {
			this.showMenus = false
			this.$router.push({ name: link })
		},
	},
}
</script>
<style lang="scss">
.btn-font-color-1 {
	color: #4b83fc !important;
}
</style>
